// extracted by mini-css-extract-plugin
export var sectionClass = "BannerWithContent-module--sectionClass--jDjG6";
export var bgImgClass = "BannerWithContent-module--bgImgClass--xNeE8";
export var bgOverlayClass = "BannerWithContent-module--bgOverlayClass--94lB5";
export var containerClass = "BannerWithContent-module--containerClass--oEG9h";
export var contentColClass = "BannerWithContent-module--contentColClass--w2l1m";
export var textClass = "BannerWithContent-module--textClass--whPyI";